import { Chip, DefinitionGrid } from "@closer/ui";

export interface ContractSummaryField {
  /** Kararlı kimlik — React anahtarı. */
  key: string;
  label: string;
  /** `null` = alan BOŞ; ekran bunu bir değer gibi değil, bir eksik gibi gösterir. */
  value: string | null;
}

export interface ContractSummaryHeaderProps {
  fields: readonly ContractSummaryField[];
  /**
   * Eksikleri doldurma yolunu anlatan cümle — çağıran veriyor.
   *
   * ⚠ Bileşen bunu KENDİ UYDURMUYOR: düzeltme yolu yetkiye bağlı (`contract.edit` +
   * kayıt düzeyi) ve salt okunur bir görüntüleyiciye "düzenleyerek tamamlayın" demek,
   * olmayan bir düğmeye yollamak olurdu.
   */
  yonlendirme?: string;
}

/**
 * Sözleşme künyesi (sunum turu, 4 Eylül 2026).
 *
 * ⚠ NEDEN: bir docx yüklendikten sonra detay ekranındaki künye alanlarının hepsi "—"
 * gösteriyordu — tür, referans, bedel, açıklama, etiketler. Kullanıcı bunu "sistem
 * dosyamı aldı ama hiçbir şey yapmadı" diye okuyordu, çünkü "—" bir EKSİK değil bir
 * DEĞER gibi duruyor.
 *
 * ⚠ Uyarı cümlesi SONUÇ İDDİA ETMİYOR, yalnız eksiği sayıyor. Canlı turda boş sorumlu
 * alanının `/api/contracts` listesinde `ownerName: null` ve `facets.owner: []` ürettiğini
 * ölçtüm, ama bunu künyedeki BEŞ alanın hepsi için tek tek doğrulamadım; "bu alanlar
 * boşken sözleşme süzgeçlerde görünmez" cümlesi o yüzden geri çekildi. Doğrulanmamış bir
 * sonucu kullanıcıya söylemek, tireden daha zararlı olurdu.
 *
 * ⚠ Kendi `Card`'ını TAŞIMIYOR: künyenin sayfadaki ağırlığına çağıran karar verir
 * (`SummaryRail` ile aynı kural).
 */
export function ContractSummaryHeader({ fields, yonlendirme }: ContractSummaryHeaderProps) {
  const eksikler = fields.filter((alan) => alan.value === null);

  return (
    <div className="flex flex-col gap-4">
      {/*
        ⚠ Uyarı IZGARANIN ÜSTÜNDE: kullanıcı alanları tek tek tarayıp eksikleri kendisi
        saymak zorunda kalmasın. Hiç eksik yoksa cümle HİÇ çizilmiyor — her zaman duran
        bir uyarı, okunmayan bir uyarıdır.
      */}
      {eksikler.length > 0 ? (
        <p data-testid="kunye-eksik-uyarisi" className="text-sm text-fg-muted">
          Künyede {eksikler.length} alan eksik:{" "}
          <span className="font-medium text-fg-strong">
            {eksikler.map((alan) => alan.label).join(", ")}
          </span>
          .{yonlendirme ? ` ${yonlendirme}` : ""}
        </p>
      ) : null}
      <DefinitionGrid
        columns={3}
        items={fields.map((alan) => ({
          key: alan.key,
          label: alan.label,
          /*
            ⚠ Boş alan "—" değil "Eksik" çipi: tire, doldurulmuş bir alanla doldurulmamış
            bir alanı aynı görünüme sokuyordu.
          */
          value: alan.value ?? <Chip label="Eksik" />,
        }))}
      />
    </div>
  );
}
